import {createFileRoute} from '@tanstack/react-router';

import {layoutTemplateKeys} from '@/features/Library/api/queryKeys';
import {getLayoutTemplates} from '@/features/Library/api/readLayoutTemplates';
import {LayoutTemplateLibrary} from '@/features/Library/components/Location/LayoutTemplateLibrary';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/locations')({
  component: LayoutTemplateLibrary,

  beforeLoad: ({context}) => {
    makeDocumentTitle('Locations');

    return {
      ...context,
      readLayoutTemplatesQuery: {
        queryKey: layoutTemplateKeys.list(),
        queryFn: () => getLayoutTemplates(),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(
      context.readLayoutTemplatesQuery
    );
  },
});
